module.exports = __webpack_public_path__ + "static/media/product-setting-icon.8a54ea7c.svg";